var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.click}},[_c('img',{class:_vm.classname})])}
var staticRenderFns = []

export { render, staticRenderFns }